import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { LanguageProvider } from './context/LanguageContext';
import Home from './pages/Home';
import Events from './pages/Events';
import PrivateEvents from './pages/PrivateEvents';
import Contact from './pages/Contact';
import TheVenue from './pages/TheVenue';
import Cart from './pages/Cart';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import TicketConfirmation from './pages/TicketConfirmation';
import TicketDisplay from './pages/TicketDisplay';
import TicketVerify from './pages/TicketVerify';
import './App.css';

// Component to scroll to top when route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Router>
          <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/private-events" element={<PrivateEvents />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/the-venue" element={<TheVenue />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/ticket-confirmation" element={<TicketConfirmation />} />
          <Route path="/ticket/:ticketId" element={<TicketDisplay />} />
          <Route path="/ticket-verify/:ticketId" element={<TicketVerify />} />
        </Routes>
          <Analytics />
          <SpeedInsights />
        </Router>
      </div>
    </LanguageProvider>
  );
}

export default App;
